<template>
    <div
    class="QR-code Wrapper w-100 h-100" >
        <div class="w-100 h-100 svg100" v-html="qrString"></div>
     </div>
   </template>
   
   <script>
   import QRCode from 'qrcode'

       export default {
           name:'qrCodeApp',
           props: {
             width: Number,
             height:Number,
             src:String,
             bg:String,
             color:String,
             noBG:Boolean   
           },
           data(){
            return{
                qrString:""
            }
           },
           watch:{
            src(){
                this.initQRCODE()
            },
            bg(){
                this.initQRCODE()
            },
            color(){
                this.initQRCODE()
            },
            noBG(){
                this.initQRCODE()
            }
           },
           mounted(){
            this.initQRCODE()
           },
           methods:{
            initQRCODE(){
                debugger // eslint-disable-line no-debugger
                var opts = {
                        margin: 1,
                        color: {
                            dark:this.color,
                            light:this.hexToHexWithOpacity(this.bg,this.noBG)
                        }   
                    }
                QRCode.toString(this.src,opts)
                    .then(url => {
                        console.log(url);
                        this.qrString = url;
                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
             hexToHexWithOpacity(hexCode, transparentBackground) {
                if (transparentBackground) {
                    return `${hexCode}00`;
                } else {
                    return `${hexCode}FF`;
                }
            }
           }
       }
   </script>

<style>
.svg100 svg{
    height: 100%;
    width: 100%;
}
</style>